'use strict';
namespace TR {

    interface RouteParams extends ng.route.IRouteService {
        tripId: string;
    }

    class CrossSellParking {

        private basketId :string;
        private searchId :string|null;
        private readonly tripId :string;

        public airportTitle :string;
        public isBusyAvailability :boolean = true;
        public isBusySelection :boolean;
        public items :Core.Parking.Quote[] = [];
        public readonly noneSelectionId :Core.Parking.Id = {CarParkCode: '-1', SupplierId: -1};
        public selectedItemId :Core.Parking.Id;
        public show :boolean;
        public terminalTitle :string;

        constructor(private $q :ng.IQService,
                    private $routeParams :RouteParams,
                    private $scope :ng.IScope,
                    private basketService :any,
                    private basketStore :any,
                    private flightsTerminalService :Core.FlightsTerminalService,
                    private resourceService :Core.ResourceService,
                    private tripService :Core.TripService) {

            this.selectedItemId = this.noneSelectionId;
            this.tripId = $routeParams.tripId;

            tripService.getTrip(this.tripId)
                .then((trip :Core.Trip.TripState) => {

                    this.basketId = <string>trip.BasketId;
                    const isOneWay = trip.FlightsRequest && trip.FlightsRequest.OneWayOnly;

                    if (isOneWay) {
                        this.show = false;
                        return;
                    }

                    if (trip.ParkingRequest) {
                        this.searchId = <string>trip.ParkingRequest.AvailabilitySearchId;
                    }

                    $q.all([
                        basketStore.parking(this.basketId),
                        this.retrieveQuotes(this.searchId, this.basketId, this.tripId),
                        basketStore.flight(trip.BasketId)
                    ]).then((results) => {

                        let selected = results[0];
                        this.items = results[1];
                        const leg = results[2].Details.Itinerary.Legs[0];

                        this.airportTitle = leg.DepartureAirport.Title;

                        flightsTerminalService.getTerminalForFlight( leg.DepartureAirport.Code,
                                                                     leg.Segments[0].FlightNumber,
                                                                     leg.DepartureDate
                        ).then(terminal => {
                            if (terminal) {
                                this.terminalTitle = terminal.Title;
                            }
                        });

                        //find the parking item from our quotes so that we can select it
                        if (selected) {
                            const item = this.findParkingItem(this.items, selected.Details.Quote.QuoteId);
                            this.selectedItemId = item.QuoteId;
                        }

                        if(!this.searchId) {
                            tripService.getTrip(this.tripId)
                                .then(trip => {
                                    return this.searchId = trip && trip.ParkingRequest
                                        && trip.ParkingRequest.AvailabilitySearchId;
                                });
                        }

                        $scope.$watch('$ctrl.selectedItemId', (n, o) => {
                            if (n && !angular.equals(n,o)) {
                                this.selectParking();
                            }
                        });

                    }).finally(() => this.isBusyAvailability = false);

            }, this.basketService.bookingAlreadyDone(`crossSellParking: '${this.tripId}'`));
        }

        private retrieveQuotes(searchId :string | null,
                               basketId :string,
                               tripId :string
                              ) :ng.IPromise<Core.Parking.Quote[]> {

            return this.basketService.getParkingQuotes(searchId, basketId, tripId)
                .then((quotes :Core.Parking.Quote[]) => {
                    let bestQuotes :Core.Parking.Quote[] = [];

                    bestQuotes = this.addBestQuote(bestQuotes, quotes, false, false);   // off airport
                    bestQuotes = this.addBestQuote(bestQuotes, quotes, false, true);    // on airport
                    bestQuotes = this.addBestQuote(bestQuotes, quotes, true, null);     // meet and greet

                    return bestQuotes;
                });
        }

        private findParkingItem(list :Core.Parking.Quote[],
                                quoteId :Core.Parking.Id
                               ) :Core.Parking.Quote {

            return _.find(list, (i) => i.QuoteId.CarParkCode === quoteId.CarParkCode);
        }

        private addBestQuote(bestQuotes: Core.Parking.Quote[],
                             quotes :Core.Parking.Quote[],
                             meetAndGreet :boolean,
                             onAirport :boolean|null
                            ) :Core.Parking.Quote[] {

            const best = _.maxBy(
                            _.filter(quotes, (quote :Core.Parking.Quote) => {
                                return quote.Facilities.MeetAndGreet === meetAndGreet &&
                                        (onAirport == null || quote.Facilities.OnAirport === onAirport);
                            })
                            , 'Ranking'
                         );

            if (best) {
                return [...bestQuotes, best];
            }
            return [...bestQuotes];
        }

        public selectParking() :void {

            this.isBusySelection = true;

            if (this.selectedItemId === this.noneSelectionId) {

                this.removeParking().finally(() => this.isBusySelection = false); //remove it

            } else {

                this.basketService.selectParking(this.selectedItemId, this.searchId, this.basketId)
                    .then(angular.noop, () => this.selectedItemId = this.noneSelectionId)
                    .finally(() => this.isBusySelection = false);
            }
        }

        public removeParking() :ng.IPromise<void> {
            return this.basketStore.removeParking(this.basketId)
                .then(() => this.basketService.updateBasket());
        }

        public getFrequencyText(frequencyInfo :Core.Parking.TransferInformation) :string {
            let description = '';

            if (frequencyInfo && (frequencyInfo.Duration || frequencyInfo.Frequency) ) {
                if (frequencyInfo.Duration === '0'){
                    description = this.resourceService.get('OPTIONSPARKINGDURATIONONAIRPORT');
                } else {
                    description = String.format(this.resourceService.get('OPTIONSPARKINGDURATIONTOAIRPORT'),
                                                frequencyInfo.Duration);
                }

                if (frequencyInfo.Frequency) {
                    const frequencyText = String.format(this.resourceService.get('OPTIONSPARKINGFREQUENCY'),
                                                        frequencyInfo.Frequency);
                    if (frequencyInfo.Duration !== '0') {
                        description = String.format('{0} ({1})', description, frequencyText);
                    } else if (!frequencyInfo.Duration){
                        description = String.format('{0} {1}', description, frequencyText);
                    }
                }
            }

            return description;
        }
    }

    angular
        .module('TR')
        .component('crossSellParking', {
            bindings: {
                show: '='
            },
            controller: CrossSellParking,
            templateUrl: 'partials/home/directivetemplate?type=CrossSellParking'
        });
}
